import React, { createContext, useEffect, useState } from "react";

const ParamsContext = createContext();

const ParamsProvider = ({ children }) => {

    const initialState = {
        texto: "",
        habilitaNombre: true,
        habilitaApellido: true,
        habilitaLocalidad: false,
        habilitaProvincia: false,
        validaEmail: false,
        validaSms: false,
        validaScore: false,
        validaDni: true,
        imagenBackground: "",
        imagenLogo: "",
        estrategia: "",
        hash: "",
        textoSobreImagen: "",
        textoDebajoImagen: "",
        textoPieFormulario: "",
        titulo1Formulario: "",
        detalle1Formulario: "",
        titulo2Formulario: "",
        detalle2Formulario: "",
        titulo3Formulario: "",
        detalle3Formulario: "",
        titulo4Formulario: "",
        detalle4Formulario: "",
        titulo5Formulario: "",
        detalle5Formulario: "",
    }

    const [paramsState, setState] = useState(initialState);

    const handleState = (newState)=>{
        setState({...newState})
    }

    const resetState = ()=>{
        setState({...initialState})
    }
    // useEffect(() => {
    //     console.log("🚀 ~ file: ParamsContext.js ~ line 48 ~ ParamsProvider ~ paramsState", paramsState)
    // }, [paramsState]);

    return (
        <ParamsContext.Provider
            value={{
                paramsState,
                setParamsState:handleState,
                resetParamsState:resetState
            }}
        >
            {children}
        </ParamsContext.Provider>
    );
};

export { ParamsProvider, ParamsContext };



// WEBPACK FOOTER //
// ./src/context/ParamsContext.js